import { render, staticRenderFns } from "./index-modern-business.vue?vue&type=template&id=1fec93e2&"
import script from "./index-modern-business.vue?vue&type=script&lang=js&"
export * from "./index-modern-business.vue?vue&type=script&lang=js&"
import style0 from "./index-modern-business.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports